import React from "react";
import Graph from "../Components/Graph";
import Header from "../Components/Header";
import Header1 from "../Components/Header1";
import { useLocation, useParams } from "react-router-dom";
import Dynamicgraph from "../Components/Dynamicgraph";

const Report = () => {
  const { id } = useParams();

  const location = useLocation();

  // Extract the token from the URL search parameters
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  if (token) {
    localStorage.setItem("token", token);
  }

  return (
    <div className="w-full flex justify-center">
      <div className=" w-full flex justify-center flex-col items-center">
        {/* <section className="2xl:container w-full sticky top-0 bg-white z-10">
          <Header />
        </section> */}
        <div className="w-full bg-white flex justify-center sticky top-0 bg-white z-20 border-b-[1px] border-gray-200">
          <div className="2xl:container w-full ">
            <Header />
          </div>
        </div>
        <div className="w-full flex justify-center flex-col items-center mb-auto bg-404A52 sticky top-20 z-10 ">
          {!token && (
            <section className="w-full 2xl:container">
              <Header1 />
            </section>
          )}
        </div>
        <section className="2xl:container w-full">
          {/* <Graph id={id} /> */}
          <Dynamicgraph id={id} />
        </section>
      </div>
    </div>
  );
};

export default Report;
